/**
 * Labstep
 *
 * @module core/Linkify
 * @desc Component to turn text to link. Wrapper around react-linkify.
 */

import React from 'react';
import ReactLinkify from 'react-linkify';

export const Linkify: RFC = ({ children }) => (
  <ReactLinkify
    componentDecorator={(decoratedHref, decoratedText, key) => (
      <a
        target="_blank"
        rel="noreferrer noopener"
        href={decoratedHref}
        key={key}
      >
        {decoratedText}
      </a>
    )}
  >
    {children}
  </ReactLinkify>
);
